export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ: FaqItem[] = [
  {
    question: 'How many olive-oil stops are in the live guide?',
    answer:
      'The live Southwest route focuses on a smaller set of dependable stops across Texas, New Mexico, and Arizona, plus stay bases that make the drive easier. The list stays compact so the route reads like a real weekend, not a giant directory.',
  },
  {
    question: 'Are these actual orchard visits or just shops?',
    answer:
      'Both. Each listing carries a visitor policy and experience type, so you can distinguish between guided orchard tastings, sommelier-style classes, retail sampling rooms, and lower-key producer visits.',
  },
  {
    question: 'What is the best base for a first weekend?',
    answer:
      'Dripping Springs is still the easiest first base because it combines the strongest orchard-style experiences with the best stay pairing. Santa Fe works well for a shorter city-tasting weekend, and Scottsdale or Phoenix works for the Arizona leg.',
  },
  {
    question: 'Why are some Southwest producers not included yet?',
    answer:
      'Because not every producer makes sense as a traveler stop. Some are production-first, seasonal, or still unclear on visitor access, so the route stays focused on places that are easier to plan around right now.',
  },
  {
    question: 'Why do hotel links open booking partners?',
    answer:
      'Hotel links open through booking partners so the site can earn a commission if you reserve a room, at no extra cost to you. The tasting stops themselves are chosen for the trip, not because they are sponsored.',
  },
  {
    question: 'Can I save the route for offline navigation?',
    answer:
      'Yes. The itinerary builder can export a GPX file so you can move the route into your mapping app before you lose signal on Southwest backroads.',
  },
];
